import React from 'react';

export const RELEASE_PROMPTS_LOCAL_STORAGE_KEY = `ReleasePrompts`;

export type ReleasePromptData = {
  route?: string;
  content: React.JSX.Element | string;
  enabled: boolean;
  expiration?: Date;
  title: string;
  promptId: number;
  code: string;
  skipMobile?: boolean;
};

export type PromptStatus = 'navigated' | 'deferred' | 'skipped';

export interface PromptState {
  status: PromptStatus;
  timestamp: string; // ISO timestamp
}

export interface PromptStates {
  promptsDisabled?: boolean;
  states: Record<number, PromptState>;
}
